import React from 'react';
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Col from 'react-bootstrap/Col';
import Row from "react-bootstrap/Row";
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, SearchBox, Hits, connectHighlight } from 'react-instantsearch-dom';
// import SmallCard from './SmallCard.js'





function AlgoliaSearch() {
    const searchClient = algoliasearch('UPMQUV2WWO', '4ce75657304871d14201f35a2c72292d');
    const Hit = ({ hit }) => (<CustomHighlight attribute="coffeeName" hit={hit} />);
  
    return (
        <Container>
        <InstantSearch searchClient={searchClient} indexName="coffee">
          <SearchBox />
          <Hits hitComponent={Hit} />
        </InstantSearch>
        </Container>
      )
    }
    
    const CustomHighlight = connectHighlight(({ highlight, attribute, hit }) => {
      const parsedHit = highlight({
        highlightProperty: '_highlightResult',
        attribute,
        hit
      });
    
      return (
        
        <Row className="justify-content-center">
        <Col
          xs={6}
          md={4}
          lg={3}
          className="py-2 px-2 d-flex align-items-stretch"
          >
        <Card border="white" className="w-100">
        <Card.Img variant="top" src={hit.coffeeImgUrl} alt={hit.coffeeCompany}/>
        <Card.Title>{hit.coffeeCompany}</Card.Title>
        <hr />
        <Card.Text>{parsedHit.map(part => part.isHighlighted ? <mark>{part.value}</mark> : part.value)}</Card.Text> 
        <Card.Body>
        </Card.Body>      
      </Card>
      </Col>
      </Row>
     
      );
    });
    
    

export default AlgoliaSearch;